import styled from 'styled-components';

export const Tooltip = styled('div')`
  max-width: 200px;
`;
